export default __webpack_public_path__ + "static/media/img-2.1d09c97f.jpg";